import { Grid, LatestNews } from '../../components';
import { useMarketIndexPrices } from '../../hooks';
import MarketIndexes from '../../shared_components/MarketIndexes/MarketIndexes';
import EpicMoversWrapper from '../EpicMovers/EpicMoversWrapper';
import HotGappersWrapper from '../HotGappers/HotGappersWrapper';
import LongTermInvestmentsWrapper from '../LongTermInvestments/LongTermInvestmentsWrapper';
import MarketCapRadarWrapper from '../MarketCapRadar/MarketCapRadarWrapper';
import PopularGroupsWrapper from '../PopularGroups/PopularGroupsWrapper';
import UpcomingEarningsWrapper from '../UpcomingEarnings/UpcomingEarningsWrapper';
import Week52GainersAndLosersWrapper from '../Week52GainersAndLosers/Week52GainersAndLosersWrapper';

import styles from './Discover.module.scss';

const Discover = () => {
  const marketIndexes = useMarketIndexPrices();
  const extraChildren = (
    <div>
      <div className={styles.news}>
        <LatestNews />
      </div>
    </div>
  );

  return (
    <Grid
      extraChildren={extraChildren}
    >
      <div className={styles.marketIndexesWrapper}>
        <MarketIndexes indexes={marketIndexes} />
      </div>
      <div className={styles.sections}>
        <div><HotGappersWrapper /></div>
        <div><EpicMoversWrapper /></div>
        <div><Week52GainersAndLosersWrapper /></div>
        <div><MarketCapRadarWrapper /></div>
        <div><PopularGroupsWrapper /></div>
        <div><LongTermInvestmentsWrapper /></div>
        <div><UpcomingEarningsWrapper /></div>
      </div>
    </Grid>
  );
};

export default Discover;
